import React, { useEffect, useState, useRef } from "react";
import { DailyReport } from "./DailyReport";
import { Box, Typography, Button, Dialog, Stack, Divider, CircularProgress, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { Translate, translate} from "react-i18nify";
import { GenerateReport, generateChartData } from "./GenerateReport";
import TimeUtils from '../../utils/TimeUtils';
import { SessionService } from "../../services/DataService";
import DownloadData from "../../utils/DownloadData";
import { styled } from "@mui/material/styles";

// TODO: Make sure cancallation is implemented if dialog is closed.
const Confirmdownload = ({ dateFrom, dateTo, patientId, open, onClose, daysTotal, activeDays}) => {
    const childRefs = useRef([]);
    const [daysTotalList, setDaysTotalList] = useState([]);
    const [fileType, setFileType] = useState(null);
    const [dataForPdf, setDataForPdf] = useState([]);
    const [pdfDone, setPdfDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataRate, setDataRate] = useState(1);
    const [fetchError, setFetchError] = useState(null);
    const [denyConfirm, setDenyConfirm] = useState(false);
    const abortControllerRef = useRef(null);
    

    useEffect(() => {
        setDaysTotalList(Array(daysTotal).fill(0))
        // if open is changed to false call to get data needs to be cancelled and already downloaded data needs to be deleted/removed from memory
    },[daysTotal, open])
    
    useEffect(() => {
        if(childRefs.current.length > 0){
            if(childRefs.current.length === dataForPdf.length && !pdfDone){
                dataForPdf.forEach((item, index) => {
                    setTimeout(() => {
                        GenerateReport(childRefs.current[index], patientId, TimeUtils.formatDateYYMMDD(item.detailedSessions[0].start), setLoading)
                    }, 100)
                })
                setPdfDone(true);
            }
        }
    }, [dataForPdf])

    const handleFileTypeChanged = (event, newFileType) => {
        setFileType(newFileType);
    };

    const handleConfirm = (ev, setLoading) => {
        setDataForPdf([]); 
        setPdfDone(false);
        childRefs.current = [];
        setLoading(true);
        var abortController = new AbortController()
        abortControllerRef.current = abortController;
        if(fileType === "pdf"){
            (async()=>{
                var daysString = ""
                daysTotal.forEach(date => {
                    daysString += date.start + ","
                })
                daysString = daysString.slice(0, -1)
                await SessionService.getDayDataMultipule(patientId, true, daysString, abortControllerRef.current).then(result => {
                    setDataForPdf(result.data)
                }).catch((err) => {
                    if(err.message !== "canceled")
                        console.error(err);
                    setFetchError(err);
                    setLoading(false);
                })
            })();            
        } else if(fileType === "csv"){
            (async()=>{
                var from = TimeUtils.getBeginningOfDay(dateFrom); // added
                var to = TimeUtils.getEndingOfDay(dateTo); // added
                await downloadReportDataRange(patientId,from,to, abortControllerRef.current, dataRate).then(data => {
                    DownloadData.donwloadCsv(data, false, from, to, setLoading);
                }).catch((err) => {
                    if(err.message !== "canceled")
                        console.error(err);
                    setLoading(false);
                    setFetchError(err);
                })

                
            })();
        }
    }

    if (!open) {
        if(abortControllerRef.current !== null){
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        if(dataForPdf.length > 0)
            setDataForPdf([]);
        return null;
    }

    return(
        <Dialog
            open={open}
            onClose={() => onClose()}
            fullWidth
            maxWidth="md"
            sx={{ width: "100%", height:"100%", overflow: "hidden"}}
        >

            <br/>          
            <Box sx={{ width: "90%", height: "600px", p:2, ml:2, display:"flex", flexDirection:"column"}} >
                <Typography variant="h5" ><Translate value="DownloadDataFiles" /></Typography>

                <Typography variant="h6" sx={{my:2}}><Translate value="SelectFileFormat" /></Typography>

                <ToggleButtonGroup
                    value={fileType}
                    exclusive
                    onChange={handleFileTypeChanged}
                    aria-label="text alignment"
                >
                    <ToggleButton color="primary" value="pdf" aria-label="left aligned" sx={{px:4, py:2}}>
                        <img style={{ height: '60px', opacity:fileType === 'pdf' ? 1 : 0.3}} src="../icon_pdf.png" alt="PDF" />
                        {translate("PdfFile")}
                    </ToggleButton>
                    <ToggleButton color="primary" value="csv" aria-label="centered" sx={{px:4, py:2}}>
                        <img style={{ height: '60px', opacity:fileType === 'csv' ? 1 : 0.3}} src="../icon_csv.png" alt="CSV" /> CSV file
                    </ToggleButton>

                </ToggleButtonGroup>
                <Box sx={{my:3}} >
                    {fileType === "pdf" ?
                        <Box sx={{display:"flex", flexDirection:"column"}} >
                            <Translate value="PdfDisclaimer"/>
                            
                            <Box sx={{display:"flex", flexDirection:"row", mt:3}} >
                                {translate("ConfirmToDownloadPdf", {totalFiles: daysTotal?.length})}
                            </Box>
                        </Box>
                    :
                        <>
                        {fileType === "csv" ?
                            <Box sx={{display:"flex", flexDirection:"column"}} >
                                {/* <Translate value="CsvDisclaimer"/> */}
                                {translate("CsvDisclaimer")}
                                
                                <Box sx={{display:"flex", flexDirection:"row", mt:3}} >
                                    {translate("ConfirmToDownloadCsv", {from: TimeUtils.formatDateDDMMYY(dateFrom), to: TimeUtils.formatDateDDMMYY(dateTo)})}
                                </Box>
                                <Box sx={{display:"flex", flexDirection:"row", mt:3}} >
                                    <Translate value="DataRateExplainer" sx={{marginLeft: 100}} />
                                </Box>
                            </Box>
                        :
                            <></>
                        }
                        </>
                    }
                </Box>
                <Stack
                spacing={2}
                sx={{width:"500px", marginLeft: 5, marginTop: 3}}
                >
                    {dataForPdf.map((fileData, index) => {
                        return(
                            <Box
                            sx={{position:"absolute" ,  display: "none"}}
                            > 
                                <DailyReport 
                                key={index}
                                data={fileData} 
                                reportData={fileData.detailedSessions}
                                chartData={generateChartData(fileData.detailedSessions)}
                                open={true}
                                date={TimeUtils.formatDateYYMMDD(fileData.detailedSessions[0].start)}
                                forwardRef={el => childRefs.current[index] = el}
                                />
                            </Box>
                        )
                    })}
                </Stack>                
            </Box>              
            {fileType === "csv" ?
            <Box>
                <DataRateSelector setDataRate={setDataRate} rateArray={[1,2,5,15,30,60]} dataRate={dataRate} activeDays={activeDays} sx={{ left: 10, bottom: 20 }} />  
            </Box>
            : 
                <></>    
            }
            <Box  position={"absolute"} sx={{bottom: 20, right: 30}} >
                <LoadingButton loading={loading} setLoading={setLoading} handleConfirm={handleConfirm} fileType={fileType} err={fetchError} setFetchError={setFetchError} denyConfirm={dataRate === undefined || dataRate === null} />
            </Box>
                
        </Dialog>
    )

}

const DataRateSelector = ({setDataRate, rateArray, dataRate, activeDays, sx }) => {
    const [colums, setColums] = useState([]);

    useEffect(() => {
        constructToggleGroupColums(rateArray)
    },[rateArray])

    // Calculation to see if current rate will exceed 1 million data points i.e create a to large for the csv file
    if(activeDays.length * 86400 / dataRate >= 1000000){   
        const newRate = rateArray.find(rate => activeDays.length * 86400 / rate <= 1000000);
        setDataRate(newRate);
    }

    const ToggleButtonStyled = styled(ToggleButton)({
        "&.Mui-selected, &.Mui-selected:hover": {
            color: "white",
            backgroundColor: '#009de0',
        }
    });

    /*Constructs the columns for the toggle buttons
    * Each column will contain up to 3 buttons and each button will have its own data rate
    * i.e rateArray[1,2,5,15,30,60] => colums[[1,2,5],[15,30,60]]
     */
    const constructToggleGroupColums = (rateArray) => {
        let columAmount = parseInt(rateArray.length / 3);
        if(rateArray.length % 3 !== 0)
            columAmount++;
        let index = 0;
        let newColums = new Array(columAmount)
        for(let i = 0; i < columAmount; i++){
            if(i === columAmount - 1){
                newColums[i] = rateArray.slice(index, rateArray.length);
            }else
                newColums[i] = rateArray.slice(index, index + 3);
            index += 3;
        }
        setColums(newColums);
    }

    const handleChange = (event, newRate) => {
        if (newRate !== null){
            setDataRate(newRate)
        }
    }
    return(
        <Box >
            {colums.map((rateArray, index) => {
                return(
                <Box position={"absolute"} sx={{bottom: sx.bottom, left: sx.left + 200 * index }} >
                    <ToggleButtonGroup
                        key={index}
                        value={dataRate}
                        orientation="vertical"
                        exclusive
                        onChange={handleChange}
                        sx={{ bottom: 0 }}
                    >
                        {rateArray.map((rate, index) => {
                            return(
                                <ToggleButtonStyled 
                                key={index} 
                                disabled={activeDays.length * 86400 / rate >= 1000000}  //Disable button if data rate will result in an csv file that exceed 1 million rows
                                value={rate}  
                                variant="contained" 
                                color="primary" 
                                sx={{ maxWidth:"180px", minHeight:"66px", fontSize: 12, ml: 2, }}>    
                                    <Translate value="DataRate" rate={rate===1 ? "" : rate} second={rate > 1 ? "seconds" : "second"} />
                                </ToggleButtonStyled>
                            )
                        })}   
                    </ToggleButtonGroup>
                </Box>
                )
            })}
        </Box>
    )
}

const LoadingButton = ({loading, setLoading, handleConfirm, fileType, err, setFetchError, denyConfirm}) => {

    //denyConfirm will disable the confirm button if the data rate is not set and it will not be set if no data rate is available that will not exceed 1 million data points

    useEffect(() => {
        if(err){
            setTimeout(() => {
                setFetchError(null)
            }, 5000)
        }
    },[err])

    return(
        <Box>
            {err ? 
                <Button disabled={fileType === null } onClick={ev => handleConfirm(ev, setLoading)} variant="contained" color="error" sx={{ minWidth:"200px", height:"40px", mb:1, ml:2, }}>    
                    <Translate value={"FailedToFetch"} statusCode={err.response.status} />
                </Button>
                :
                <Button disabled={fileType === null ? true : denyConfirm } onClick={ev => handleConfirm(ev, setLoading)} variant="contained" color="primary" sx={{ minWidth:"200px", height:"40px", mb:1, ml:2, }}>    
                    {loading ? 
                        <CircularProgress size={24} sx={{color: "white"}}/>
                    :
                        <Translate value="ConfirmDownload"/>
                    }
                </Button>
            }
        </Box>
    );

}

export default Confirmdownload;

export const downloadReportDataRange = async(id,from,to,abortController, dataRate = 1) => {
  return await SessionService.getDayDataRange(
    id,
    TimeUtils.localToUtc(from),
    TimeUtils.localToUtc(to),
    abortController,
    dataRate
    ).then((response) => {
      return response.data;
    }).catch((err) => {
      throw err;
  });
}